import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.COUNTRY_LIST = function (state, payload) {
  state.country_list = payload
}

const state = {
  rows: [],
  row: null,
  condition: {},
  country_list: []
}

const actions = {
  init: ({ commit, state }, condition) => {
    const ctx = {
      data: {
        init_project: { api: 'P0301ProjectService.doSearch' },
        getCountryListSelectBox: { api: 'C0001CountryService.getCountryListSelectBox' }
      }
    }

    return client.postData(ctx)
      .then((data) => {
        commit('FIND_ALL', data.init_project.output)
        commit('COUNTRY_LIST', data.getCountryListSelectBox.output)
      })
  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0001User cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0001User search')
    return client.postData({ data: { search: { api: 'P0301ProjectService.searchDataDetails', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  doFilterProject: ({ commit, state }, condition) => {
    return client.postData({ data: { doFilterProduct: { api: 'P0301ProjectService.doSearch', input: condition } }
    })
      .then((data) => {
        commit('FIND_ALL', data.doFilterProduct.output)
      })
  },
  add: ({ commit, state }, row) => {
    console.debug('called M0001User add')
    commit('EDIT',
      {
        id: null,
        is_publish: 1,
        files: []
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0001User edit')
    return client.postData({ data: { find: { api: 'P0301ProjectService.doEdit', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0001User delete')
    return client.postData({ data: { delete: { api: 'P0301ProjectService.doDelete', input: row } } })
      .then((data) => {
        commit('EDIT', null)
        commit('FIND_ALL', data.delete.output)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0001User save')
    return client.postData({ data: { save: { api: 'P0301ProjectService.doSave', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
        commit('FIND_ALL', data.save.output)
      })
  }

}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
